// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__KwZSR","colCheckbox":"styles_colCheckbox__1rcR7"};